import { TeaBlocksError } from './../../TeaBlocksError';
import { ReturnBlock } from "../ReturnBlock";
import { VoidBlock } from "../VoidBlock";
import { Shape } from "./Shape";

/**
 * Block for moving a shape.
 */
export class MoveBlock extends VoidBlock {
    shape: ReturnBlock; // a GetShapeBlock, tho madlads can use constants that start with $.
    x: ReturnBlock;
    y: ReturnBlock;

    /**
     * Constructor
     * @param inputs the inputs (shape is inputs[0]; x is inputs[1]; y is inputs[2])
     */
    constructor(id: string, inputs: ReturnBlock[]) {
        super(id)
        this.shape = inputs[0];
        this.x = inputs[1];
        this.y = inputs[2];
    }

    /**
     * Adds x and y to the position of the shape.
     * @param varEnv variable environment
     */
    *evalBlock(varEnv: Map<string, any>) {
        let shapeName: string = String(this.shape.evalBlock(varEnv));
        let shape: Shape = varEnv.get(shapeName);

        if(!shape) throw new TeaBlocksError('This shape does not exist', this.id);

        let x = Number(this.x.evalBlock(varEnv));
        let y = Number(this.y.evalBlock(varEnv));

        if (isNaN(x)|| isNaN(y)) {
            throw new TeaBlocksError("Input not a number", this.id);
        }

        shape.posX += x;
        shape.posY += y;

        varEnv.set(shapeName, shape);

        yield;
    }


}